const hasCustomFavicon = () => !!window.chatwootConfig?.customFavicon;

export const showBadgeOnFavicon = () => {
  if (hasCustomFavicon()) return; // Custom favicons don't have badge variants

  const favicons = document.querySelectorAll('.favicon');
  favicons.forEach(favicon => {
    const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  if (hasCustomFavicon()) return; // Custom favicons don't need switcher

  const favicons = document.querySelectorAll('.favicon');
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const oldFileName = `/favicon-${favicon.sizes[[0]]}.png`;
        favicon.href = oldFileName;
      });
    }
  });
};
